import { addEffect, invalidate, applyProps } from 'react-three-fiber';
import { update, Globals, FrameLoop } from '@react-spring/core';
export * from '@react-spring/core';
import { createStringInterpolator } from '@react-spring/shared/stringInterpolation';
import colorNames from '@react-spring/shared/colors';
import * as THREE from 'three';
import { extendAnimated, withAnimated } from '@react-spring/animated';

const elements = Object.keys(THREE).filter(key => /^[A-Z]/.test(key)); // Extend animated with all the available THREE elements

const animated = extendAnimated(withAnimated, [...elements, 'primitive'], true);

if (addEffect) addEffect(update);
Globals.assign({
  defaultElement: 'group',
  frameLoop: addEffect && new FrameLoop({
    requestFrame: invalidate
  }),
  applyAnimatedValues: applyProps,
  createStringInterpolator,
  colorNames
});

export { animated as a, animated };
//# sourceMappingURL=index.js.map
